import { type RouteRecordRaw } from 'vue-router'

import { useFestivalStore } from './festival.store'

export const FestivalRouter: RouteRecordRaw[] = [
  {
    path: '/festival',
    component: async () => import('./Festival.vue'),
    async beforeEnter() {
      await useFestivalStore.getState().loadFestival()
    },
  },
]
